module.exports = __webpack_public_path__ + "img/bk-back.svg";